import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PointItem } from "../types/PointItem";
import { createPointItem, getPointItem, upsertPointItem } from "../services/points";
import { pageContainerStyle, pageHeadingStyle, buttonStyle, buttonBackgroundColor } from "../components/Style";
import RoundBox from "../components/RoundBox";

export default function PointItemCardPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const isNew = id === undefined;

  const [title, setTitle] = useState("");
  const [score, setScore] = useState<number>(0);
  const [popoverInput, setPopoverInput] = useState<string>("");
  const [active, setActive] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      if (!isNew && id) {
        const item = await getPointItem(id);
        if (item) {
          setTitle(item.title);
          setScore(item.score);
          setPopoverInput((item.popoverItems || []).join("\n"));
          setActive(item.active ?? true);
        }
      }
    })();
  }, [id, isNew]);

  const canSave = useMemo(() => title.trim().length > 0, [title]);

  const handleSave = async () => {
    const popoverItems = popoverInput
      .split(/\n/)
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    if (isNew) {
      await createPointItem({ title: title.trim(), score, popoverItems, active });
    } else if (id) {
      const updated: PointItem = { id, title: title.trim(), score, popoverItems, active };
      await upsertPointItem(updated);
    }
    navigate("/point/settings");
  };

  return (
    <div style={pageContainerStyle}>
      <h2 style={pageHeadingStyle}>{isNew ? "포인트 항목 추가" : "포인트 항목 수정"}</h2>
      <RoundBox label="포인트 항목" direction="vertical" style={{ maxWidth: 720 }}>
        <div style={{ display: "grid", gridTemplateColumns: "160px 1fr", rowGap: 14, columnGap: 12, alignItems: "center" }}>
          <label style={{ fontWeight: 600 }}>포인트 부여(회수) 이유</label>
          <input value={title} onChange={(e) => setTitle(e.target.value)} style={{ padding: 8, borderRadius: 6, border: "1px solid #e5e7eb" }} />

          <label style={{ fontWeight: 600 }}>부여(회수) 점수</label>
          <input type="number" value={score} onChange={(e) => setScore(Number(e.target.value))} style={{ padding: 8, borderRadius: 6, border: "1px solid #e5e7eb", width: 160 }} />

          <label style={{ fontWeight: 600, alignSelf: "start", marginTop: 4 }}>팝오버 항목</label>
          <div>
            <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 6 }}>한 줄에 하나씩 입력하세요. 1개 이상이면 버튼 클릭 시 팝오버가 반드시 표시됩니다.</div>
            <textarea value={popoverInput} onChange={(e) => setPopoverInput(e.target.value)} rows={6} style={{ width: "100%", maxWidth: 720, padding: 8, borderRadius: 6, border: "1px solid #e5e7eb" }} />
          </div>

          <label style={{ fontWeight: 600 }}>활성</label>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} style={{ cursor: "pointer", width: 18, height: 18 }} />
            <span style={{ color: "#6b7280", fontSize: 14 }}>체크하면 포인트 관리 페이지에 표시됩니다</span>
          </div>
        </div>

        <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
          <button onClick={handleSave} disabled={!canSave} style={{ ...buttonStyle, ...(canSave ? buttonBackgroundColor.save : {}) }}>
            저장
          </button>
          <button onClick={() => navigate(-1)} style={{ ...buttonStyle, ...buttonBackgroundColor.cancel }}>
            취소
          </button>
        </div>
      </RoundBox>
    </div>
  );
}
